import React, { useState } from 'react';

import { ReactComponent as IconDropDownArrow } from 'src/assets/svgs/icon-menu-close.svg';
import { ReactComponent as UserIcon } from 'src/assets/svgs/icon-options-user.svg';
import { ReactComponent as LogoutIcon } from 'src/assets/svgs/icon-options-logout.svg';

interface Props {
  openerText: string;
  logoutFn: () => void;
}

export enum NavOptionsMenuTestID {
  Button = 'NavOptionsMenuTestID.Button',
  Menu = 'NavOptionsMenuTestID.Menu',
  Wrapper = 'NavOptionsMenuTestID.Wrapper',
  ClickAway = 'NavOptionsMenuTestID.ClickAway',
}

export const NavOptionsMenu: React.FC<Props> = ({ logoutFn, openerText }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpenState = () => setIsOpen(!isOpen);

  const options = [{ text: 'Log out', fn: logoutFn, icon: <LogoutIcon /> }];

  return (
    <div className="flex-1 flex-col items-end z-50" data-testid={NavOptionsMenuTestID.Wrapper}>
      <button
        className="flex gap-4 items-center px-2 justify-between font-semibold focus:outline-none"
        data-testid={NavOptionsMenuTestID.Button}
        onClick={toggleOpenState}
      >
        <span className="mb-1">
          <UserIcon />
        </span>
        {openerText}
        <span className={isOpen ? '' : 'transform rotate-180'}>
          <IconDropDownArrow />
        </span>
      </button>
      {isOpen && (
        <>
          <div
            className="absolute top-0 right-0 left-0 h-screen"
            data-testid={NavOptionsMenuTestID.ClickAway}
            onClick={() => setIsOpen(false)}
          />
          <div
            className="absolute flex right-0 mt-2 mr-2 py-2 w-48 bg-white rounded-md shadow-xl"
            data-testid={NavOptionsMenuTestID.Menu}
          >
            {options.map((option) => (
              <button
                key={option.text}
                className="flex flex-grow gap-6 items-center px-4 py-2 text-sm text-gray-800 hover:bg-gray-100"
                onClick={option.fn}
              >
                <span>{option.icon}</span>
                {option.text}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
